export default {
	loading: '加载中...',
	web: {
		index: {
			login: "登录",
			sigupForFree: "免费注册"
		},
		signin: {
			email: "请输入邮箱",
			password: "请输入密码"
		},
		signup: {
			email: "请输入邮箱",
			password: "请输入密码（8-20位）",
			repassword: "确认输入密码"
		},
		rules: {
			emailCount: "长度不少于5位数",
			passwordCount: "长度在8到20位数",
		},
		forgetpassword: {
			email: "您的邮箱",
			code: "验证码"
		}
	},
	common: {
		close: "关闭",
		save: "保存",
		bye: "再见",
		cancel: "取消",
		sure: "确定",
		back: "返回",
		refresh: "刷新",
		update: "更新",
		later: "以后再说",
		add: "添加",
		clear: "清空",
		inDevelopment: "正在开发",
		items: "项",
		retry: "全部重试",
		unopened: "暂未开放",
		traffic: "流量"
	},
	home: {
		myDrives: "云盘列表",
		transfer: "云传输",
		sync: "云同步",
		myTasks: "任务列表",
		gift: "商店",
		resource: "友情链接"
	},
	cloud: {
		new: "云盘",
		emptuyCloudList: "云盘列表空空如也",
		emptuyList: "空空如也",
		newFolder: "新建文件夹",
		emptyFolder: "这个文件夹是空的.",
		invalidTip:"已失效，请更新授权",
		oauthInvalid:"该云盘已过期，请更新授权信息",
		refresh: "刷新容量",
		update: "修改名称",
		delete: "删除云盘",
		reloadAuth: "更新授权",
		deletingCloud: "移除云盘",
		deleteTip: "该云盘有任务正在进行中, 移除云盘将会停止并删除与该云盘相关的所有任务, 确定要继续移除吗？",
		addSuccessTip: "云盘授权成功",
		addExistTip: "云盘授权已刷新",
		addFailTip: "云盘授权失败，或联系客服",
		addSuccess: "云盘添加成功, 请回到界面并刷新云盘列表",
		addExplain: "您可以在以下以开放的云盘列表中点击进行授权登录，点击后将弹出的第三方授权登录页面或跳转到第三方官网授权。",
		endExplain: "未来我们将会支持更多的云盘类型，如有您有希望尽快增加的云盘，请通过留言板告诉我们~感谢支持",
		baidu: "百度网盘",
		chinamobile: "中国移动云盘",
		drive123: "123云盘",
		webdav: "Webdav",
		tencent: "腾讯微云",
		ftp: "FTP",
		jianguoyun: "坚果云",
		drive115: "115网盘",
		thunder: "迅雷云盘",
		wps: "WPS文档",
		ai360:"360AI云盘",
		quark: "夸克网盘",
		guangya:"光鸭云盘",
		aliyun: "阿里云盘",
		onedrive: "微软云盘",
		googleDrive: "谷歌云盘",
		dropbox: "Dropbox",
		future: "在未来，我们将开发和支持更多的第三方云盘产品，如果你有想要添加的云盘类型，你可以通过电子邮件告诉我们，后续开放：",
		explorer: {
			myFiles: "根目录",
			name: "名称",
			size: "大小",
			updateTime: "更新时间",
			open: "打开",
			refresh: "刷新",
			delete: "删除",
			preview: "预览",
			rename: "重命名",
			mkdir: "新建文件夹",
			download: "下载",
			copyTo: "传输到",
			moveTo: "移动到",
			site: "跳转官网",

		},
		file: {
			pic: "图片",
			vedio: "视频",
			audio: "音频",
			book: "书籍"
		}
	},
	task: {
		new: "任务",
		title: "任务列表",
		newTask: "新建任务",
		deleteEmpty: "清空列表",
		empty: "任务列表是空的",
		restart: "重启",
		continue: "续传",
		resume: "恢复",
		delete: "删除",
		completed: "文件及文件夹成功率",
		status: {
			running: "运行中",
			waiting: "等待",
			success: "成功",
			failure: "失败",
			lessSuccess: "部分成功",
			mostSuccess: "大部分成功",
			cancel: "取消",
			pause:"暂停",
			recover:"继续",
			unkown: "未知"
		},
		delTitle: "删除任务",
		delTip: "是否要删除该任务？如果任务正在进行，删除后将会停止。",
		itemsSelected: "项被选中",
		sourceNotSelect: "未选择传输源",
		destinationNotSelect: "未选择传输目的地",
		createTip: "云端传输，无需在线，随时随地可登录查看.",
		syncCreateTip: "云端同步，当前默认同步间隔为1天"
	},
	transfer: {
		desc:"该功能支持将A云存储的文件/目录直接传输到B云存储的目录中，整个过程在云端离线运行。",
		addNewCloud: "添加云盘",
		source: "选择来源",
		baiduPath: "/apps/小迈千云",
		baiduOldPath:"/apps/小迈Board",
		baiduRoot: "只能选择\" /我的应用数据/小迈千云 \"文件夹及子项",
		thunderLimit: "迅雷暂不支持作为来源",
		destination: "选择目标",
		setting: "设置",
		chipLable: "后缀名如: mp4",
		filterTip: "文件类型过滤器允许你设置自己的过滤规则,包含或者排除设置的选项,系统将根据文件名称的后缀来确定,您可以输入文件类型,如zip、jpg:",
		include: "包含下列文件",
		exclude: "排除下列文件",
		conflictTile: "文件冲突策略",
		taskName: "任务名称",
		cloudTips: "来源和目标单击名称可以进入云盘或文件夹",
		sendEmail: "任务完成后将结果发送到邮件",
		createNow: "开始传输",
		createSync: "开始同步",
		inLine: "该任务正在排队",
		calculating: "正在计算",
		timeRemaining: "估算时间",
		rateTip: "非SVIP下载通常会受官方权益限制，在传输小文件时，由于文件较小，速度看起来也会较慢哦",
		shortSpeed:"",
		folder: "文件夹",
		file: "文件",
		size: "大小",
		skipped: "已跳过",
		failed: "已失败",
		stopTitle: "停止任务",
		stopTip: "是否要停止当前正在运行的任务？",
		stop: "停止",
		cancel: "取消",
		loading: "加载中...",
		from: "来源",
		to: "目标",
		total: "共",
		items: "项",
		stoppingTask: "正在停止任务",
		taskSetting: "任务设置",
		fileConfict: "文件冲突策略",
		confictTip: "在云盘数据传输过程中,若发生文件冲突,将采取您在下列中所选中的策略来处理。",
		notificationEmail: "通知邮件",
		notificationPhoneTip: "请填写您的手机号码",
		notificationEmailTip: "请填写您的邮箱地址",
		time: "时间",
		avgRate: "平均速度",
		startTime: "开始时间",
		endTime: "结束时间",
		failDetails: "错误详情",
		FailDetails: "错误列表",
		path: "路径",
		cause: "原因",
	},
	sync: {
		desc:"该功能支持将A云存储的目录与B云存储的目录建立同步关系，定期同步，整个过程在云端离线运行。",
		resumeTitle: "恢复同步",
		resumeTip: "是否立即恢复同步"
	},
	user: {
		vipTipTitle: "技术服务反馈",
		vipNow: "点击反馈",
		vipGroup: "技术反馈",
		vipDesc: "您可以扫描下方微信二维码，可以反馈遇到的问题或系统故障，我们将最快为您响应。",
		messageWant: "在这里反馈问题",
		messageBoardBut: "留言板",
		changeAvatar: "更换头像",
		avatarPreview: "预览",
		avatarUpload: "上传头像",
		avatarUploadClick: "点击上传",
		orderList: "订单记录",
		changePassword: "修改密码",
		resetPassword: "修改密码",
		newPassword: "输入你的新密码",
		reNewPassword: "重复你的新密码",
		checkPassword: "两次密码不一致",
		newPasswordCheck: "密码长度限制在8-20位",
		oldPassword: "输入你的旧密码",
		oldPasswordCheck: "密码长度限制在8-20位",
		passwordLimit: "至少8位长度",
		passwordSuccess: "密码修改成功",
		showPassword: "显示",
		logout: "退出",
		del: "注销账号",
		connectUs: "联系我们",
		start: "开始",
		feedback: "问题反馈",
		passwordCheck: "密码长度限制在8-20位",
		unlimited: "无限",
		sessionExpired: "登录会话已过期，请重新登录",
		feedbackDescribe: "亲爱的用户，非常感谢您使用我们的产品，如果在使用过程中出现问题，您可以反馈到以下邮箱，我们将在24小时内处理并回复您。在邮件中，您可以带来您的账号、问题详情、配合操作步骤或图片、视频等，这有利于帮您更快的定位问题，谢谢!"
	},
	gift: {
		type: {
			MONTHLY: "月会员用户"
		},
		compare: "查看权益说明",
		pricingTable: "云流量-套餐表",
		orderDetails: "订单详情",
		describe: {
			a: "1. 有限套餐均可重复购买且叠加，无限套餐不可叠加。",
			b: "2. 在使用产品传输、同步、上传、下载等功能时，每个文件消耗同等大小流量。",
			c: "3. 套餐仅提供AB之间传输文件产生的流量及带宽速度，不提供绕过云盘官方限速的任何服务。",
			d: "4. 点击此处可查看各云盘限制规则及速度说明",
			e: "5. 有了您的鼓励我们才能给您更好的产品，感谢支持！如有疑问可"
		},
		currentPlan: "当前套餐",
		order: "立即订购",
		vipDocument: "付费权益",
		freeDocument: "免费权益",
		other: {
			a: "1.套餐提供的速度为多文件常规并发数量下的最大支持速度，实际速度受到云盘官方会员权益、文件大小等影响。",
			b: "2.无限套餐用户在总使用量超过设计阈值时，后续运行速度会有一定幅度降低。",
			c: "3.套餐价格及权益可能随运营情况做出调整和变更，最终解释权归本站所有。"
		},
		multi: {
			desc: "* 单次的订购量有效期为1年，多次购买可重复叠加流量."
		},
		a: {
			title: {
				size: "30G",
				ext: "/月",
				sale: "￥0",
				name: "基础体验版",
				number: "2312Free",
				speed: '低速',
				time:"每月",
				id: "1"
			},
			color: "#617589",
			disabled: true,
			btnText: "无需订购",
			content: free()
		},
		b: {
			title: {
				size: "3000G",
				ext: "/月",
				sale: "￥49.8",
				name: "进阶升级版",
				number: "3000G-30D-Y2601",
				speed: '高速',
				time:"1个月",
				id: "52"
			},
			color: "#4aa377",
			badge: "最爱买",

			content: vip()
			
		},
		c: {
			title: {
				size: "500G",
				ext: "/月",
				sale: "￥19.8",
				name: "尝鲜优选版",
				number: "500G-31D-Y2601",
				speed: '高速',
				time:"1个月",
				id: "49"
			},
			color: "#7D9C58",

			content: vip()
		},
		d: {
			title: {
				size: "6000G",
				ext: "/季",
				sale: "￥79.8",
				name: "季度进取版",
				number: "6000G-90D-Y2601",
				speed: '高速',
				time:"3个月",
				id: "53"
			},
			color: "#dc792a",
			

			content: vip()
		},
		
		e: {
			title: {
				size: "无限",
				ext: "/季",
				sale: "￥168",
				name: "季度畅享版",
				number: "Unlimit-3M-2510",
				time:"3个月",
				speed: '高速',
				id: "44"
			},
			color: "#5b036b",
			badge: "最畅销",
			content: vip()

		},
		// f: {
		// 	title: {
		// 		size: "无限",
		// 		ext: "/半年",
		// 		sale: "￥248",
		// 		name: "半年通享版",
		// 		number: "Unlimit-HY-2602",
		// 		speed: '高速',
		// 		time:"半年",
		// 		id: "54"
		// 	},
		// 	color: "#212121",
		// 	content: vip()
		// },
		
	}
}

function free() {
	return {
		a: "部分云盘",
		b: "普通传输通道",
		c: "最多2个云盘",
		d: "仅传输单个文件",
		e: "单文件不超过10G",
		f: "",
	}
}

function vip() {
	return {
		a: "10+国内主流云盘",
		b: "高速传输通道",
		c: "云同步功能",
		d: "多个文件并行",
		e: "60G内大文件",
		f: "文件夹传输",
		g: "人工服务支持",
		h: "通道优先传输"
	}
}